import { render, staticRenderFns } from "./feeding.vue?vue&type=template&id=ad364928&scoped=true&"
import script from "./feeding.vue?vue&type=script&lang=js&"
export * from "./feeding.vue?vue&type=script&lang=js&"
import style0 from "./feeding.vue?vue&type=style&index=0&id=ad364928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad364928",
  null
  
)

export default component.exports